import React, {useCallback, useEffect} from 'react'
import View from './view'
import {Helmet} from 'react-helmet'
import {useSelector} from 'react-redux'
import {selectOrganization} from '../../../redux/courses'
import {selectMember} from '../../../redux/members'
import {useAppDispatch} from '../../../redux/configureStore'
import {useAuth} from '../../../components/AuthProvider'
import {
  getReportedExamResults,
  selectNcarbAttempts,
} from '../../../redux/reportExamStatus'

const DashboardPage = () => {
  const auth = useAuth()

  const dispatch = useAppDispatch()

  const organization = useSelector(selectOrganization)
  const member = useSelector(selectMember)
  const examReports = useSelector(selectNcarbAttempts)

  const loadDashboard = useCallback(async () => {
    await dispatch(getReportedExamResults({auth}))
  }, [dispatch, auth.isAuthenticated])

  useEffect(() => {
    if (auth.isAuthenticated) {
      loadDashboard()
    }
  }, [loadDashboard])

  return (
    <>
      <Helmet>
        <title>{`Dashboard | Black Spectacles`}</title>
      </Helmet>
      <View
        organization={organization}
        member={member}
        examReports={examReports}
      />
    </>
  )
}

export default DashboardPage
